import Instagram from "../../assets/svgs/instagram-fill-svgrepo-com.svg";
import Linkedin from "../../assets/svgs/linkedinv2-fill-svgrepo-com.svg";
import GitHub from "../../assets/svgs/github-outline-fill-svgrepo-com.svg";
import "./SocialMedias.css";

const SocialMedias = () => {
  return (
    <div className="socialMedias">
      <a
        target="_blank"
        href="https://www.linkedin.com/in/jovicarvalho/"
        rel="noreferrer"
      >
        <img src={Linkedin} alt="Ícone do Linkedin" />
      </a>
      <a
        href="https://github.com/jovicarvalho"
        target="_blank"
        rel="noreferrer"
      >
        <img src={GitHub} alt="Ícone do Github" />
      </a>

      <a
        href="https://www.instagram.com/jovitcarvalho/"
        target="_blank"
        rel="noreferrer"
      >
        <img src={Instagram} alt="Ícone do UInstagram" />
      </a>
    </div>
  );
};

export default SocialMedias;
